import { render } from "./PortalLayout.vue?vue&type=template&id=8c646184&scoped=true"
import script from "./PortalLayout.vue?vue&type=script&lang=js"
export * from "./PortalLayout.vue?vue&type=script&lang=js"

import "./PortalLayout.vue?vue&type=style&index=0&id=8c646184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c646184"]])

export default __exports__